<template>
  <el-card
    v-if="Transdraft"
    :style="'height:calc(100vh - 100px);overflow:auto;'+((Transdraft.exectime<1000)?'background-color: #6c9e6d;':'')"
  >
    <el-row slot="header">
      <el-col :md="20" :xs="18" style="height: 60px;overflow:auto">
        <div style="width:600px">
          <el-button type="danger" @click="deleteThis()" v-if="!isNew">
            <i class="material-icons">delete_forever</i>
          </el-button>
          <el-button
            type="warning"
            title="αλλαγη επαφης"
            @click="keepBusinessPanel=!keepBusinessPanel"
          >
            <i class="material-icons">contacts</i>
          </el-button>

          <el-button type="success" @click="repeatTrans('month')" v-if="Transdraft.type=='dept'">
            M
            <i aria-hidden="true" class="icon material-icons">update</i>
          </el-button>
          <el-button @click="repeatTrans('year');" type="warning" v-if="Transdraft.type=='dept'">
            Y
            <i aria-hidden="success" class="icon material-icons">update</i>
          </el-button>
          <template v-if="ctx=='in'">
            <a :href="'/dashboard.html#/timologiera/'+Transdraft.timologioid">
              <el-button v-if="Transdraft.timologioid">
                {{Transdraft.refnum}}
                <i class="material-icons">receipt</i>
              </el-button>
            </a>
            <el-button
              v-if="!Transdraft.timologioid&&(Transdraft.type=='dept'||Transdraft.type=='contract')"
              title="Εκδωσε σχετικό παραστατικό"
              @click="$router.push({name: 'timologio',params: {id:'new'},query:{draftid:Transdraft.id}})"
            >
              +
              <i class="material-icons">receipt</i>
            </el-button>
          </template>
        </div>
      </el-col>
      <el-col :md="4" :xs="6">
        <el-button type="success" style="float:right;" plain @click="udateRecord()">
          <i
            title="αυτη η συνδιαλλαγή είναι απενεργοποιημένη"
            class="material-icons"
            v-if="(Transdraft.exectime<1000)"
          >remove_circle</i>
          <!-- <i
            aria-hidden="true"
            class="icon material-icons"
            v-if="Transdraft.type=='dept'"
          >shopping_cart</i>
          <i aria-hidden="true" class="icon material-icons" v-else>euro_symbol</i>-->
          <i class="material-icons">save</i>
        </el-button>
        <el-button
          type="success"
          plain
          style="float:right;"
          v-if="Transdraft.type&&Transdraft.type.indexOf('dept')>=0&&!editNote"
          @click="payTheTans()"
          title="Πληρώστε αυτήν την χρέωση"
        >
          <i class="material-icons">euro_symbol</i>
        </el-button>
      </el-col>
    </el-row>
    <el-row>
      <business-panel
        ref="businessDetails"
        v-if="!Transdraft.businessId||keepBusinessPanel"
        @businessChange="changeBusiness"
        :businessId="Transdraft.businessId"
        embed-mode
      ></business-panel>

      <el-row>
        <!-- <p>{{Transdraft}}</p> -->
        <el-card class="in-card">
          <el-row :gutter="10">
            <el-col :md="editNote?24:16">
              <el-col :md="24">Τίτλος</el-col>
              <el-col :md="24">
                <el-input placeholder="Τι αφορά..." v-model="Transdraft.title"></el-input>
              </el-col>
            </el-col>
            <el-col :md="8" v-if="!editNote">
              <el-col :md="24">Αρ.Παραστ.</el-col>
              <el-col :md="24">
                <el-input placeholder="..." v-model="Transdraft.refnum"></el-input>
              </el-col>
            </el-col>

            <el-col :md="9">
              <el-col :md="24">Κατηγορίες</el-col>
              <el-col :md="24">
                <s-tag-select
                  style="width:100%"
                  multiple
                  filterable
                  placeholder="Για τί πρόκειται..."
                  v-model="Transdraft.tags"
                  :end-point="qTags"
                  value-prop="tags"
                  label-prop="tags"
                ></s-tag-select>
              </el-col>
            </el-col>
            <el-col :md="9">
              <el-col :md="24">Έδρα</el-col>
              <el-col :md="24">
                <s-tag-select
                  style="width:100%"
                  multiple
                  filterable
                  placeholder="Που.."
                  v-model="Transdraft.place"
                  :end-point="qPlaces"
                  value-prop="place"
                  label-prop="place"
                ></s-tag-select>
              </el-col>
            </el-col>
            <el-col :md="6">
              <el-col :md="24">Εργατοωρες</el-col>
              <el-col :md="24">
                <el-input placeholder="..." v-model="Transdraft.workload"></el-input>
              </el-col>
            </el-col>
          </el-row>
          <el-divider></el-divider>
          <!-- </el-card>
      </el-row>
      <el-row>
          <el-card class="in-card">-->
          <el-row v-if="!editNote">
            <!-- <p>{{lastMoneyInput}}</p> -->
            <el-col :md="7">
              <el-col :md="24">Συνολικο Ποσο</el-col>
              <el-col :md="24">
                <s-number
                  name="cost"
                  @keypress="lastMoneyInput = 'all';sync_cost()"
                  xinput="sync_cost()"
                  v-model="Transdraft.cost"
                />
              </el-col>
            </el-col>
            <el-col :md="6">
              <el-col :md="24">ΦΠΑ</el-col>
              <el-col :md="24">
                <s-number v-model="Transdraft.vat" @input="sync_vat()" />
              </el-col>
            </el-col>
            <el-col :md="7">
              <el-col :md="24">Ποσο χωρις ΦΠΑ</el-col>
              <el-col :md="24">
                <s-number
                  v-model="Transdraft.pretaxcost"
                  @keypress="lastMoneyInput = 'pretax';sync_pretaxcost()"
                  xinput="sync_pretaxcost()"
                />
              </el-col>
            </el-col>

            <el-col :md="4">
              <el-col :md="24">Πηρωμη σε</el-col>
              <el-col :md="24">
                <el-select
                  v-model="Transdraft.paymenttype"
                  placeholder="Select"
                  clearable
                  filterable
                >
                  <el-option key="cash" label="Μετρητα" value="cash"></el-option>
                  <el-option key="bank" label="Τραπεζα" value="bank"></el-option>
                  <el-option key="visa" label="VISA" value="visa"></el-option>
                  <el-option key="stock" label="Πιστοτικο" value="stock"></el-option>
                  <el-option key="other" label="Αλλο" value="other"></el-option>
                </el-select>
              </el-col>
            </el-col>
          </el-row>
        </el-card>
      </el-row>
      <el-row>
        <el-card class="in-card">
          <el-col :md="8">
            <el-col :md="24">Καταγραφή</el-col>
            <el-col :md="24">
              <r-dater
                :xs="24"
                exportFormat="unixtime"
                v-model="Transdraft.time"
                import-format="unixtime"
                placeholder="Ημερομηνία"
                type="date"
              ></r-dater>
            </el-col>
          </el-col>
          <el-col :md="8">
            <el-col :md="24">Υπενθύμιση</el-col>
            <el-col :md="24">
              <r-dater
                exportFormat="unixtime"
                import-format="unixtime"
                v-model="Transdraft.alerttime"
                placeholder="Ημερομηνία"
                type="date"
              ></r-dater>
            </el-col>
          </el-col>
          <el-col :md="8" v-if="!editNote">
            <el-col :md="24">Ισχυεί από</el-col>
            <el-col :md="24">
              <r-dater
                import-format="unixtime"
                exportFormat="unixtime"
                v-model="Transdraft.exectime"
                placeholder="Ημερομηνία"
                type="date"
              ></r-dater>
            </el-col>
          </el-col>
        </el-card>
      </el-row>
      <el-row>
        <el-card class="in-card">
          <el-row>
            <el-input
              type="textarea"
              :rows="2"
              v-model="Transdraft.discription"
              placeholder="Περιγραφή"
            ></el-input>
          </el-row>
          <el-divider></el-divider>

          <el-upload
            class="upload-demo"
            drag
            :on-preview="downloadFile"
            :data="prUploadParams"
            action="/assets/components/receipt/connector.php"
            :file-list="files"
            :before-upload="udateRecord"
            multiple
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              πεταξε το αρχειο εδώ
              <em>ή κανε click εδω για να επισυναψεις αρχειο</em>
            </div>
            <!-- <div class="el-upload__tip" slot="tip">jpg/png files with a size less than 500kb</div> -->
          </el-upload>
        </el-card>
      </el-row>
    </el-row>
  </el-card>
</template>

<script>
import * as api from "~/api/resource";
import _ from "lodash";
export default {
  name: "r-trans-draft",
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    transactionData: {
      type: Object,
      default: () => {},
    },
    invoiceData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      lastMoneyInput: null,
      // ctx: "in",
      editNote: false,
      uploadParams: {
        HTTP_MODAUTH: window.Receipt.auth,
        ctx: "BootstrapVersion",
        action: "gears/upload",
      },
      Transdraft: null,
      keepBusinessPanel: false,
      editBusiness: false,
      resolveBusiness: false,
      seachBusiness: null,
      // selectedBusiness: {},
      businessData: {},
      userProfile: UserProfile,
      loaded: false,
    };
  },
  watch: {
    async "transactionData.id"(v, vo) {
      _log_("reload dd..", v);
      if (v && v != vo) {
        this.prepareTrans();
        // this.Transdraft = await api.getObject("transdrafts/get", {
        //   id: v
        // });
      }
    },
    async "$route.params.transid"(v, vo) {
      _log_("reload this.$route.params.transid..", v);
      if (v != vo) {
        this.prepareTrans();
        // this.Transdraft = await api.getObject("transdrafts/get", {
        //   id: v
        // });
      }
    },
  },
  methods: {
    async prepareTrans() {
      // this.Transdraft = {}
      const valId = this.$route.params.transid
        ? this.$route.params.transid
        : this.transactionData
        ? this.transactionData.id
        : null;
      if (!valId) return;
      _log_("yello", this.transactionData);
      if (valId && !isNaN(parseInt(valId))) {
        // _log_("reloadGO..", parseInt(this.$route.params.transid));
        this.Transdraft = await api.getObject("transdrafts/get", {
          id: valId,
        });
      } else {
        this.editNote = valId == "newnote";
        _log_("reload dd..is..", this.editNote, this.transactionData);
        this.Transdraft = await api.getObject("transdrafts/get", {
          type: valId != "newdept" ? "payment" : "dept",
          isincome: this.ctx == "in",
          businessId: this.$route.params.id,
        });
        // this.Transdraft = this.transactionData;
        this.Transdraft.id = null;
      }
      return;
    },
    sync_pretaxcost() {
      // this.lastMoneyInput == "pretax";
      if (this.Transdraft.vat) {
        this.Transdraft.cost =
          this.Transdraft.pretaxcost *
          (1 + (this.Transdraft.vat ? this.Transdraft.vat / 100 : 0));
      } else this.Transdraft.cost = this.Transdraft.pretaxcost;
    },
    sync_vat() {
      if (this.Transdraft.vat) {
        if (
          this.Transdraft.pretaxcost !== null &&
          this.Transdraft.pretaxcost != "" &&
          this.lastMoneyInput == "pretax"
        )
          this.Transdraft.cost =
            this.Transdraft.pretaxcost *
            (1 + (this.Transdraft.vat ? this.Transdraft.vat / 100 : 0));
        else if (this.Transdraft.cost !== null && this.Transdraft.cost != "")
          this.Transdraft.pretaxcost =
            this.Transdraft.cost /
            (1 + (this.Transdraft.vat ? this.Transdraft.vat / 100 : 0));
      }
      // this.lastMoneyInput = "vat";
    },
    sync_cost() {
      // this.lastMoneyInput == "cost";
      if (this.Transdraft.vat) {
        this.Transdraft.pretaxcost =
          this.Transdraft.cost /
          (1 + (this.Transdraft.vat ? this.Transdraft.vat / 100 : 0));
      } else this.Transdraft.pretaxcost = this.Transdraft.cost;
    },
    async changeBusiness(e) {
      this.keepBusinessPanel = true;

      this.Transdraft.businessId = e.businessId;
      // if (this.selectedInvoice.businessId != e.businessId) {
      //   this.selectedInvoice.businessId = e.businessId;
      //   await this.updateInvoice();
      // } else {
      //   this.selectedInvoice.business_name = e.name;
      //   this.selectedInvoice.business_afm = e.afm;
      //   this.selectedInvoice.business_alias = e.alias;
      //   this.$refs.listedInvoices.updateRow(
      //     { timologioId: this.selectedInvoice.timologioId },
      //     this.selectedInvoice
      //   );
      // }

      _log_("changed....", this.Transdraft);
      // if (this.selectedInvoice.nvoiceid) {
      //new

      // this.$refs.updateInvoices.appendRecord(this.selectedInvoice)

      // }
      // e=>(selectedInvoice.businessId=e.businessId)
    },
    async deleteThis() {
      //pipeActions(['->confirmAction','Transdraft=>transdrafts/remove','->reloadTrans','->closeLastModal']);
      const vm = this;
      this.$confirm("Ειστε βεβαιως οτι θέλετε να το διαγράψετε?", {
        confirmButtonText: "Βεβαιότατος",
        cancelButtonText: "Άστο καλήτερα",
        type: "warning",
        center: true,
      })
        .then(async () => {
          var { data } = await api.removeObject("transdrafts", vm.Transdraft);
          // _log_('>>>>',data)
          if (data && data.success) {
            vm.$emit("delete", vm.Transdraft);
          }
        })
        .catch(() => {
          // vm.seachBusiness = vm.searchString;
        });
    },
    async repeatTrans(period) {
      this.Transdraft.isincome = this.ctx == "in";
      try {
        var { data } = await api.updateProcessor(
          "transdrafts/update",
          this.Transdraft
        );
        //  this.$emit("save", this.Transdraft);
        this.Transdraft.repeat = period;
        var r = await api.updateProcessor(
          "transdrafts/update",
          this.Transdraft
        );
        //   this.$emit("new", r);
        this.$router.replace({ params: { transid: r.id } });
        // this.routeGo({
        //     name: this.resolveRoute(),
        //     params: { transid: r.id }
        //   });
      } catch (error) {
        this.$message.error("Υπάρχει είδη επανάλυψη");
      }

      // pipeActions(['Transdraft=>transdrafts/update>+transactions','->checkFailure','#searchDrafts'],{id:'','repeat':'month'});
    },
    async udateRecord() {
      // _log_("upppppp", this.ctx);
      if (this.ctx) this.Transdraft.isincome = this.ctx == "in";
      if (!this.Transdraft.businessId) {
        this.$notify.error({
          title: "Κατι λείπει",
          message: "Ποιος πελάτης?",
        });
        return;
      }
      const isNew = !this.Transdraft.id;
      this.Transdraft = await api.updateProcessor(
        "transdrafts/update",
        this.Transdraft
      );
      if (isNew) this.$emit("new", this.Transdraft);
      else this.$emit("save", this.Transdraft);
      return true;
    },
    // async qTags(q) {
    //   // ="{postParams:{businessId:Transdraft.businessId},editable:true}"
    //   const r = await api.fetchProcessor("transdrafts/vuegetfieldoptions", {
    //     businessId: this.Transdraft.businessId,
    //     for: this.$route.params.direction,
    //     query: q,
    //     valueField: "tags",
    //     labelField: "tags"
    //   });
    //   _log_("taggg..", r);
    //   return r.data.results;
    // },
    // resolveRoute() {
    //   const sanitise = [
    //     "intagsintrans",
    //     "incontactintrans",
    //     "outtagsouttrans",
    //     "outcontactouttrans"
    //   ];
    //   _log_("taggg..", this.$route);
    //   return sanitise.indexOf(this.$route.name) < 0
    //     ? this.$route.name + this.ctx + "trans"
    //     : this.$route.name;
    // },

    downloadFile(e) {
      _log_(e);
      this.downloadURL(e.url);
    },
    // async checkRecord(){},
    pipeActions() {},
    goToLink() {},
    payTheTans() {
      let msg = "Αυτή η ενέργεια θα δημιουργήσει ταυτόχρονα χρέωση και πληρωμή",
        vm = this;
      if (vm.Transdraft.id) {
        if (vm.Transdraft.balanse == vm.Transdraft.deptamound)
          msg =
            "Αυτή η χρέωση φένεται πληρωμένη???? συγουρα θέλεται να ξαναπληρωθεί?";
        else
          msg = "Αυτή η ενέργεια θα δημιουργήσει πληρωμή για αυτήν την χρέωση";
      }
      this.$confirm(msg, "ΠΡΟΣΟΧΗ!!!", {
        type: vm.Transdraft.id ? "warning" : "danger",
        typeAnimated: true,
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
      })
        .then(async () => {
          //pipeActions(['Transdraft=>transdrafts/update','->reloadTrans'],{id:'','type':'payment','cost':(Transdraft.deptamound-Transdraft.balanse),'paytime':'now',balanse:0});transDialog = false;

          // if (vm.Transdraft.id) {
          //   let payload = _.cloneDeep(vm.Transdraft);
          //   payload.id = "";
          //   payload.type = "payment";
          //   payload.cost =
          //     parseFloat(payload.deptamound) - parseFloat(payload.balanse);
          //   payload.balanse = 0;
          //   payload.exectime = "now";
          //   payload.paytime = "now";
          //   var npayload = await api.updateProcessor(
          //     "transdrafts/update",
          //     payload
          //   );
          //   if (!npayload) {
          //     alert(
          //       "Η εγγραφή δεν καταχωρήθικε !!!!προσοχή!!!! σταματάω περετέρω ενεργειες"
          //     );
          //     return false;
          //   } else {
          //     vm.Transdraft = npayload;
          //     // reloadTrans();
          //   }
          // } else {
          this.Transdraft.isincome = this.ctx == "in";
          const event = vm.Transdraft.id ? "save" : "new";
          var payload = await api.updateProcessor(
            "transdrafts/update",
            vm.Transdraft
          );
          this.$emit(event, payload);
          _log_("heloooo...", payload, vm.Transdraft);
          if (!payload) {
            alert(
              "Η εγγραφή δεν καταχωρήθικε !!!!προσοχή!!!! σταματάω περετέρω ενεργειες"
            );
            return false;
          } else {
            payload.id = "";
            payload.type = "payment";
            payload.cost =
              parseFloat(payload.deptamound) - parseFloat(payload.balanse);
            payload.balanse = 0;
            payload.exectime = "now";
            payload.paytime = "now";
            var npayload = await api.updateProcessor(
              "transdrafts/update",
              payload
            );
            if (!npayload) {
              alert(
                "Η εγγραφή δεν καταχωρήθικε !!!!προσοχή!!!! σταματάω περετέρω ενεργειες"
              );
              return false;
            } else {
              vm.Transdraft = npayload;
              vm.$emit("new", vm.Transdraft);
              // reloadTrans();
            }
          }
          // }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Delete canceled",
          });
        });
    },
  },
  computed: {
    isNew() {
      if (!this.Transdraft) return;
      return isNaN(parseInt(this.Transdraft.id));
    },
    prUploadParams() {
      return { ...this.uploadParams, draftid: this.Transdraft.id };
    },
    files() {
      var fs = [];
      // _log_("helll,", window.location.hostname);
      if (this.Transdraft && this.Transdraft.attatchments)
        this.Transdraft.attatchments.forEach((f) => {
          fs.push({ name: f.description, url: f.url });
        });
      _log_("helllFILES,", fs);
      return fs;
    },
  },
  async mounted() {
    // this.ctx = this.$route.params.direction
    //   ? this.$route.params.direction
    //   : "in";
    await this.prepareTrans();
  },
};
</script>

<style>
.el-card.in-card {
  margin-top: 3px;
  margin-bottom: 3px;
  padding-top: 5px;
  padding-bottom: 5px;
}
.in-card .el-col {
  padding-left: 3px;
  padding-right: 3px;
}
div.option {
  padding: 3px;
  border-bottom: 1px solid seagreen;
}
div.quoted {
  font-size: 11px;
  font-style: italic;
}
div.option div.main {
  font-weight: bold;
}
</style>
